import {Injectable} from '@angular/core';
import {BaseService} from "../../../../../../base/services/base.service";
import {AuthService} from "../../../../../common/modules/auth/services/auth.service";
import {NotifierService} from "../../../../../../base/services/notifier/notifier.service";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {EventBusService} from "../../../../../../base/services/eventbus/event-bus.service";
import {IParams} from "../../../../../../base/endpoints/iparams";
import {DashEndpoint} from "../../../../dash.endpoint";
import {IPage, ResponseData} from "../../../../../../base/models/pagination.model";
import {IWebsite, IWebsiteConfig, IWebsiteDetail, IWebsiteReq} from "../models/website.model";
import {IAuth} from "../../../../../common/modules/auth/models/auth.model";

@Injectable({
  providedIn: 'root'
})
export class WebsiteService extends BaseService {

  constructor(
    authService: AuthService,
    notifier: NotifierService,
    private http: HttpClient,
    private eventBusService: EventBusService
  ) {
    super(authService, notifier)
  }

  search(key: string, endpoint: string, params: IParams) {
    let url = DashEndpoint.BLOGS.SEARCH(endpoint, params)
    this.http.get<ResponseData<IPage<IWebsite>>>(url)
      .subscribe((data: ResponseData<IPage<IWebsite>>) => {
        this.eventBusService.publish(key, data.body)
      }, error => {
        this.handleError(error, (auth: IAuth) => {
          this.search(key, endpoint, params)
        }, (err: HttpErrorResponse) => {
          this.eventBusService.publish(this.getErrorKey(key), err)
        })
      })
  }

  fetchSingle(key: string, endpoint: string, id: number) {
    this.http.get<ResponseData<IWebsiteDetail>>(DashEndpoint.BLOGS.GET(endpoint, id))
      .subscribe((data: ResponseData<IWebsiteDetail>) => {
        this.eventBusService.publish(key, data.body)
      }, (error: HttpErrorResponse) => {
        this.handleError(error, (auth: IAuth) => {
          this.fetchSingle(key, endpoint, id)
        }, (err: HttpErrorResponse) => {
          this.eventBusService.publish(this.getErrorKey(key), err)
        })
      })
  }

  fetchBySlug(key: string, slug: string) {
    this.http.get<ResponseData<IWebsiteDetail>>(DashEndpoint.BLOGS.GET_BY_SLUG_PUBLIC(slug))
      .subscribe((data: ResponseData<IWebsiteDetail>) => {
        this.eventBusService.publish(key, data.body)
      }, (error: HttpErrorResponse) => {
        this.handleError(error, (auth: IAuth) => {
          this.fetchBySlug(key, slug)
        }, (err: HttpErrorResponse) => {
          this.eventBusService.publish(this.getErrorKey(key), err)
        })
      })
  }

  upsert(key: string, endpoint: string, blogReq: IWebsiteReq, exId: number | null) {
    let url = exId == null ? DashEndpoint.BLOGS.CREATE(endpoint)
      : DashEndpoint.BLOGS.UPDATE(endpoint, exId)

    let observable = exId == null ?
      this.http.post<ResponseData<IWebsiteDetail>>(url, blogReq)
      : this.http.patch<ResponseData<IWebsiteDetail>>(url, blogReq)

    observable.subscribe(res => {
      this.eventBusService.publish(key, res.body)
    }, (err: HttpErrorResponse) => {
      this.handleError(err, (auth: IAuth) => {
        this.upsert(key, endpoint, blogReq, exId)
      }, (err: HttpErrorResponse) => {
        this.eventBusService.publish(this.getErrorKey(key), err)
      })
    })
  }

  upsertConfig(key: string, websiteId: number, req: IWebsiteConfig) {
    let url = DashEndpoint.BLOGS.UPSERT_CONFIG(websiteId)

    this.http.patch<ResponseData<IWebsiteDetail>>(url, req)
      .subscribe(res => {
        this.eventBusService.publish(key, res.body)
      }, (err: HttpErrorResponse) => {
        this.handleError(err, (auth: IAuth) => {
          this.upsertConfig(key, websiteId, req)
        }, (err: HttpErrorResponse) => {
          this.eventBusService.publish(this.getErrorKey(key), err)
        })
      })
  }

  publish(key: string, endpoint: string, blogId: number, publish: boolean) {
    let url = DashEndpoint.BLOGS.PUBLISH(endpoint, blogId, {published: publish})

    this.http.patch<ResponseData<IWebsiteDetail>>(url, null)
      .subscribe(res => {
        this.eventBusService.publish(key, res.body)
      }, (err: HttpErrorResponse) => {
        this.handleError(err, (auth: IAuth) => {
          this.publish(key, endpoint, blogId, publish)
        }, (err: HttpErrorResponse) => {
          this.eventBusService.publish(this.getErrorKey(key), err)
        })
      })
  }

}
